/**
 * RetiredChartMindRoute.jsx — mounts the retired page on old ChartMind v1 routes.
 * Shaped by: Prompt 21; owner decisions 2026-10-08.
 * Invariants: display only; does not write chartmind documents; access errors fail closed to Retry.
 * Related: RetiredAppPage.jsx, useClinicalHudAccess.js.
 */
import React, { useState } from "react";
import useClinicalHudAccess from "features/clinicalHud/app/hooks/useClinicalHudAccess";
import RetiredAppPage from "./RetiredAppPage";

function RetiredChartMindAccess({ onRetry }) {
  const { canAccess, loading, error } = useClinicalHudAccess();
  return (
    <RetiredAppPage
      appName="ChartMind"
      replacementName="ClinicalHUD2"
      replacementPath="/clinical-hud-2"
      hasReplacementAccess={canAccess}
      accessLoading={loading}
      accessError={Boolean(error)}
      onRetry={onRetry}
    />
  );
}

export default function RetiredChartMindRoute() {
  const [retryNonce, setRetryNonce] = useState(0);
  return (
    <RetiredChartMindAccess
      key={retryNonce}
      onRetry={() => setRetryNonce((n) => n + 1)}
    />
  );
}
